import { render } from "./Icon.vue?vue&type=template&id=31d4d74e"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"
script.render = render

export default script